import React, { CSSProperties } from 'react';
import TokenRender from './TokenRender';
import { DraggableObject, MoveTokenObject } from '../../reducers/drag/dragReducer';

interface DragTokenProps {
    dragInfo: DraggableObject,
    style?: CSSProperties,
    alt?: string,
    className?: string
}

const DragToken = ({ dragInfo, style, alt, className  }: DragTokenProps) => {
    const info = (dragInfo as MoveTokenObject);
    return info?.details.token ? (
        <TokenRender
            token={info.details.token}
            style={style}
            alt={alt}
            className={className}
        />
    ) : null;
};

export default DragToken;
